@if ((shouldDisplayProfileActions$ | async) === true) {
    @if (company$ | async; as company) {
        <div class="flex flex-row gap-2">
            <div
                class="flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-5 py-2.5">
                <span class="text-sm font-medium text-black">
                    {{
                        'corpoImpactProfile.publish-profile-toggle' | transloco
                    }}
                </span>
                <mat-slide-toggle
                    color="accent"
                    [formControl]="publishedControl">
                </mat-slide-toggle>
            </div>
            @if (publishedControl.value === true) {
                <button
                    (click)="copyLink()"
                    class="flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-5 py-2.5 text-black">
                    <mat-icon
                        svgIcon="heroicons_outline:clipboard-document"
                        class="text-black"></mat-icon>
                    <span class="text-sm font-medium">
                        {{ 'corpoImpactProfile.copy-link' | transloco }}
                    </span>
                </button>
            }

            <button
                class="text-sm"
                mat-raised-button
                color="accent"
                (click)="openProfile(company)">
                <span class="mr-2">
                    {{ 'corpoImpactProfile.preview-profile' | transloco }}
                </span>
                <mat-icon iconPositionEnd>open_in_new</mat-icon>
            </button>
        </div>
    }
}
